import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-422101c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-container" }
const _hoisted_2 = ["src", "alt"]

import { withDefaults, computed, ComputedRef } from "vue"

/* ------------------- Props ----------------- */

interface PropsInterface {
	url?: string;
	defaultUrl?: string;
	alt?: string;
	/**
	 * Size can be: sm, md, lg(default)
	 */
	size?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Image',
  props: {
    url: { default: "" },
    defaultUrl: { default: "https://www.pngkey.com/png/detail/233-2332677_image-500580-placeholder-transparent.png" },
    alt: { default: "image" },
    size: { default: "lg" }
  },
  setup(__props: any) {

const props = __props as { url: string, defaultUrl: string, alt: string, size: string };



/* ------------------- Properties ----------------- */

const hasImage: ComputedRef<boolean> = computed(() => props.url.length > 0)
const imageUrl: ComputedRef<string> = computed(() => hasImage.value ? props.url : props.defaultUrl)
const widthSize: ComputedRef<string> = computed(() => {
	switch (props.size) {
	case "sm": {
		return "25%"
	}
	case "md": {
		return "50%"
	}
	case "lg":
	default:
		return "100%"
	}
})
const constructedStyle: ComputedRef<string> = computed(() => {
	return `
	width: ${widthSize.value};
	`
})



/* ------------------- Lifecycle ----------------- */
/*
onMounted(async () => {

});
*/


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(imageUrl))
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "image",
          style: _normalizeStyle(_unref(constructedStyle)),
          src: _unref(imageUrl),
          alt: __props.alt
        }, null, 12, _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}
}

})